import { calculateFontSize } from '../../utils'
import { fontSizes } from './fontSizes'

const pageUrl = window.location.pathname.split('/')[1]
const subPage = window.location.pathname.split('/')[3]

const styles = () => ({
  ckEditorFont: props => ({
    '& .simple-box p:not(.card-header p)': {
      fontSize: props.fontSize
        ? calculateFontSize(fontSizes.p, props.fontSize)
        : fontSizes.p,
      padding: '8px 0 8px 0',
      display: 'block !important',
      margin: '0 !important',
      fontFamily: props.fontFamily || 'Inter !important',
      lineHeight: '28px',
      fontWeight: '400 !important',
    },
    '&  .ck.ck-editor__editable': {
      padding:
        props.page === 'landing-page'
          ? ' 0 0 48px 0 !important'
          : '12px 0 48px 0 !important',
    },
    '& .simple-box': {
      maxWidth:
        props.page === 'page' || props.page === 'completion'
          ? '800px !important' // mini-course 800px
          : pageUrl === 'collection'
          ? '1200px !important' // Collection 1200px
          : props.theme === 0
          ? '1200px !important' // mini-course landing page theme 0 1200px
          : '692px !important', // mini-course landing page theme not 0 692px
    },
    '& .raw-html-embed': {
      maxWidth:
        props.page === 'page' || props.page === 'completion'
          ? '800px !important' // mini-course 800px
          : pageUrl === 'collection'
          ? '1200px !important' // Collection 1200px
          : props.theme === 0
          ? '1200px !important' // mini-course landing page theme 0 1200px
          : '692px !important', // mini-course landing page theme not 0 692px
    },
    '& .simple-box table td .ck-table-bogus-paragraph': {
      fontSize: props.fontSize
        ? calculateFontSize(fontSizes.p, props.fontSize)
        : fontSizes.p,
      padding: '8px 0 8px 0',
      display: 'block !important',
      margin: '0 !important',
      fontFamily: props.fontFamily || 'Inter !important',
      lineHeight: '28px',
      fontWeight: '400 !important',
    },
    '& .simple-box table th .ck-table-bogus-paragraph': {
      fontSize: props.fontSize
        ? calculateFontSize(fontSizes.p, props.fontSize)
        : fontSizes.p,
      display: 'block !important',
      margin: '0 !important',
      fontFamily: props.fontFamily || 'Inter !important',
      lineHeight: '28px',
      fontWeight: 'bold !important',
    },
    '& .simple-box .table th p': {
      fontSize: props.fontSize
        ? calculateFontSize(fontSizes.p, props.fontSize)
        : fontSizes.p,
      padding: '0 !important',
      display: 'block !important',
      margin: '0 !important',
      fontFamily: props.fontFamily || 'Inter !important',
      lineHeight: '28px',
      fontWeight: 'bold !important',
    },
    '& .simple-box ul': {
      fontSize: props.fontSize
        ? calculateFontSize(fontSizes.p, props.fontSize)
        : fontSizes.p,
      padding: '8px 0 8px 0',
      display: 'block !important',
      margin: '0 !important',
      fontFamily: props.fontFamily || 'Inter !important',
      lineHeight: '28px',
      fontWeight: '400 !important',
      marginLeft: '20px !important',
    },
    '& .simple-box ol': {
      fontSize: props.fontSize
        ? calculateFontSize(fontSizes.p, props.fontSize)
        : fontSizes.p,
      padding: '8px 0 8px 0',
      margin: '0 !important',
      fontFamily: props.fontFamily || 'Inter !important',
      lineHeight: '28px',
      fontWeight: '400 !important',
      marginLeft: '20px !important',
    },

    '& .simple-box li': {
      fontSize: props.fontSize
        ? calculateFontSize(fontSizes.p, props.fontSize)
        : fontSizes.p,
      padding: '8px 0 8px 0',
      margin: '0 !important',
      fontFamily: props.fontFamily || 'Inter !important',
      lineHeight: '28px',
      fontWeight: '400 !important',
    },
    '& .simple-box .table td p': {
      fontSize: props.fontSize
        ? calculateFontSize(fontSizes.p, props.fontSize)
        : fontSizes.p,
      padding: '8px',
      display: 'block !important',
      margin: '0 !important',
      fontFamily: props.fontFamily || 'Inter !important',
      lineHeight: '28px',
      fontWeight: '400 !important',
    },
    '& .simple-box h1': {
      fontSize: props.fontSize
        ? calculateFontSize(fontSizes.h1, props.fontSize)
        : fontSizes.h1,
      padding: '8px 0 8px 0 !important',
      fontFamily: props.fontFamily ? props.fontFamily : 'Inter !important',
      lineHeight: '44px',
      fontWeight: '600 !important',
      margin: '0 !important',
    },
    '& .simple-box h2': {
      fontSize: props.fontSize
        ? calculateFontSize(fontSizes.h2, props.fontSize)
        : fontSizes.h2,
      padding: '8px 0 8px 0 !important',
      fontFamily: props.fontFamily ? props.fontFamily : 'Inter !important',
      lineHeight: '36px',
      fontWeight: '500 !important',
      margin: '0 !important',
    },
    '& .simple-box h3': {
      fontSize: props.fontSize
        ? calculateFontSize(fontSizes.h3, props.fontSize)
        : fontSizes.h3,
      padding: '8px 0 8px 0 !important',
      fontFamily: props.fontFamily ? props.fontFamily : 'Inter !important',
      lineHeight: '32px',
      fontWeight: '500 !important',
      margin: '0 !important',
    },
  }),
})

export default styles
